import { render, staticRenderFns } from "./DynamicCrudTable.vue?vue&type=template&id=e8a388a6"
import script from "./DynamicCrudTable.vue?vue&type=script&lang=js"
export * from "./DynamicCrudTable.vue?vue&type=script&lang=js"
import style0 from "./DynamicCrudTable.vue?vue&type=style&index=0&id=e8a388a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports